import { CellProps, TRowEntity } from 'react-table';
import { IconButton } from '@higo/ui';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useIsAnyAssignExaminationMutating } from 'hooks/mutations/assignExamination';
import { getLiveVisitRoute } from 'routes';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useUserPermissions } from 'hooks/useUserPermissions';

export type ShowWithoutAssignVisitCellRendererProps = {
  examinationId: number;
  patientId?: number;
};

const Button = styled(IconButton)`
  margin: 0 8%;
`;

export const ShowWithoutAssignVisitCellRenderer = <T extends TRowEntity>({
  cell,
  selection,
}: CellProps<T, ShowWithoutAssignVisitCellRendererProps>) => {
  const examinationId = cell.row.original.id;
  const navigate = useNavigate();
  const { visitPermission } = useUserPermissions();
  const isVisitReadPermission = visitPermission?.read;
  const isAnyExamMutating = useIsAnyAssignExaminationMutating();
  const isAnyExamSelected = Number(selection?.selectedIds.length) > 0;

  const handleClick = () => {
    navigate(getLiveVisitRoute(examinationId), {
      state: {
        visitId: examinationId,
      },
    });
  };

  return (
    <Tooltip
      placement="right"
      title={<FormattedMessage id="table.header.show" />}
      color="#72799C"
    >
      <Button
        color="secondary"
        size="small"
        icon={<EyeOutlined />}
        onClick={handleClick}
        disabled={
          !isVisitReadPermission || !!isAnyExamMutating || isAnyExamSelected
        }
        id="assign-icon-button"
      />
    </Tooltip>
  );
};
